// vocabulary/elementary.ts
import { VocabPair } from './types';

export const elementary: VocabPair[] = [
  { word: "Enormous", definition: "Very big" },
  { word: "Curious", definition: "Eager to learn or know" },
  { word: "Ancient", definition: "Very old" },
  { word: "Brave", definition: "Showing courage" },
  { word: "Fragile", definition: "Easily broken" },
  { word: "Peculiar", definition: "Strange or unusual" },
  { word: "Brilliant", definition: "Very smart or bright" },
  { word: "Delicious", definition: "Tastes very good" },
  { word: "Magnificent", definition: "Extremely beautiful or impressive" },
  { word: "Gentle", definition: "Kind and soft" },
  { word: "Swift", definition: "Moving very fast" },
  { word: "Cheerful", definition: "Happy and positive" },
  { word: "Mysterious", definition: "Hard to understand or explain" },
  { word: "Graceful", definition: "Moving in a smooth, elegant way" },
  { word: "Generous", definition: "Willing to give and share" },
  { word: "Cozy", definition: "Warm and comfortable" },
];